import { Controller } from "@hotwired/stimulus";

// The public site's phone menu (TASK-228). The menu is a full-width <dialog>
// (Www::MobileNav::Component); this opens it with showModal(), which is what
// gives it the top layer, Esc-to-close, a focus trap and an inert page — none
// of which the old in-header dropdown had.
//
// The page-scroll lock is CSS (html:has(.www-mobile-nav[open])), so it lifts
// itself however the dialog closes, including a Turbo visit that removes it.
export default class extends Controller {
  static targets = ["dialog", "menuButton"];

  connect() {
    // A dialog left open when the window grows past lg would be display:none
    // (lg:hidden) yet still modal — an inert page with nothing on it. Close it.
    // lg, not md, since the v2 nav (five links + three buttons) needs 1024px.
    this.desktop = window.matchMedia("(min-width: 1024px)");
    this.onBreakpoint = (event) => { if (event.matches) this.close(); };
    this.desktop.addEventListener("change", this.onBreakpoint);

    // Never let Turbo snapshot the page with the menu open, or Back restores it.
    this.beforeCache = () => this.close();
    document.addEventListener("turbo:before-cache", this.beforeCache);
  }

  disconnect() {
    this.desktop?.removeEventListener("change", this.onBreakpoint);
    document.removeEventListener("turbo:before-cache", this.beforeCache);
  }

  open() {
    if (!this.hasDialogTarget || this.dialogTarget.open) return;

    this.dialogTarget.showModal();
    this.menuButtonTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    if (!this.hasDialogTarget || !this.dialogTarget.open) return;

    this.dialogTarget.close();
  }

  // The dialog's own close/cancel events, so Esc (which the browser handles)
  // keeps the hamburger's state honest too.
  closed() {
    this.menuButtonTarget.setAttribute("aria-expanded", "false");
  }
}
